import React from 'react';
import ZoneIntervention from '../components/ZoneIntervention';
import { ZONES_SEO } from '../seo/pagesSeo';

function Zone91() {
    const seo = ZONES_SEO['91'];
     const cities = [
        "Antiquaire Abbéville-la-Rivière (91150)",
        "Antiquaire Angerville (91670)",
        "Antiquaire Angervilliers (91470)",
        "Antiquaire Arpajon (91290)",
        "Antiquaire Arrancourt (91690)",
        "Antiquaire Athis-Mons (91200)",
        "Antiquaire Authon-la-Plaine (91410)",
        "Antiquaire Auvernaux (91830)",
        "Antiquaire Auvers-Saint-Georges (91580)",
        "Antiquaire Avrainville (91630)",

        "Antiquaire Ballainvilliers (91160)",
        "Antiquaire Ballancourt-sur-Essonne (91610)",
        "Antiquaire Baulne (91590)",
        "Antiquaire Bièvres (91570)",
        "Antiquaire Blandy (91150)",
        "Antiquaire Boigneville (91720)",
        "Antiquaire Bois-Herpin (91150)",
        "Antiquaire Boissy-la-Rivière (91690)",
        "Antiquaire Boissy-le-Cutté (91590)",
        "Antiquaire Boissy-le-Sec (91870)",
        "Antiquaire Boissy-sous-Saint-Yon (91790)",
        "Antiquaire Bondoufle (91070)",
        "Antiquaire Boullay-les-Troux (91470)",
        "Antiquaire Bouray-sur-Juine (91850)",
        "Antiquaire Boussy-Saint-Antoine (91800)",
        "Antiquaire Boutervilliers (91150)",
        "Antiquaire Boutigny-sur-Essonne (91820)",
        "Antiquaire Bouville (91880)",
        "Antiquaire Brétigny-sur-Orge (91220)",
        "Antiquaire Breuillet (91650)",
        "Antiquaire Breux-Jouy (91650)",
        "Antiquaire Brières-les-Scellés (91150)",
        "Antiquaire Briis-sous-Forges (91640)",
        "Antiquaire Brouy (91150)",
        "Antiquaire Brunoy (91800)",
        "Antiquaire Bruyères-le-Châtel (91680)",
        "Antiquaire Buno-Bonnevaux (91720)",
        "Antiquaire Bures-sur-Yvette (91440)",

        "Antiquaire Cerny (91590)",
        "Antiquaire Chalo-Saint-Mars (91780)",
        "Antiquaire Chalou-Moulineux (91740)",
        "Antiquaire Chamarande (91730)",
        "Antiquaire Champcueil (91750)",
        "Antiquaire Champlan (91160)",
        "Antiquaire Champmotteux (91150)",
        "Antiquaire Chatignonville (91410)",
        "Antiquaire Chauffour-lès-Étréchy (91580)",
        "Antiquaire Cheptainville (91630)",
        "Antiquaire Chevannes (91750)",
        "Antiquaire Chilly-Mazarin (91380)",
        "Antiquaire Congerville-Thionville (91740)",
        "Antiquaire Corbeil-Essonnes (91100)",
        "Antiquaire Corbreuse (91410)",
        "Antiquaire Courances (91490)",
        "Antiquaire Courdimanche-sur-Essonne (91720)",
        "Antiquaire Courson-Monteloup (91680)",
        "Antiquaire Crosne (91560)",

        "Antiquaire D’Huison-Longueville (91590)",
        "Antiquaire Dannemois (91490)",
        "Antiquaire Dourdan (91410)",
        "Antiquaire Draveil (91210)",

        "Antiquaire Écharcon (91540)",
        "Antiquaire Égly (91520)",
        "Antiquaire Épinay-sous-Sénart (91860)",
        "Antiquaire Épinay-sur-Orge (91360)",
        "Antiquaire Étampes (91150)",
        "Antiquaire Étiolles (91450)",
        "Antiquaire Étréchy (91580)",
        "Antiquaire Évry-Courcouronnes (91000)",

        "Antiquaire Fleury-Mérogis (91700)",
        "Antiquaire Fontaine-la-Rivière (91690)",
        "Antiquaire Fontenay-le-Vicomte (91540)",
        "Antiquaire Fontenay-lès-Briis (91640)",
        "Antiquaire Forges-les-Bains (91470)",

        "Antiquaire Gif-sur-Yvette (91190)",
        "Antiquaire Gironville-sur-Essonne (91720)",
        "Antiquaire Gometz-la-Ville (91400)",
        "Antiquaire Gometz-le-Châtel (91940)",
        "Antiquaire Grigny (91350)",
        "Antiquaire Guibeville (91630)",
        "Antiquaire Guigneville-sur-Essonne (91590)",
        "Antiquaire Guillerval (91690)",

        "Antiquaire Igny (91430)",
        "Antiquaire Itteville (91760)",

        "Antiquaire Janville-sur-Juine (91510)",
        "Antiquaire Janvry (91640)",
        "Antiquaire Juvisy-sur-Orge (91260)",

        "Antiquaire La Ferté-Alais (91590)",
        "Antiquaire La Forêt-le-Roi (91410)",
        "Antiquaire La Forêt-Sainte-Croix (91150)",
        "Antiquaire La Norville (91290)",
        "Antiquaire La Ville-du-Bois (91620)",
        "Antiquaire Lardy (91510)",
        "Antiquaire Le Coudray-Montceaux (91830)",
        "Antiquaire Le Mérévillois (91660)",
        "Antiquaire Le Plessis-Pâté (91220)",
        "Antiquaire Le Val-Saint-Germain (91530)",
        "Antiquaire Les Granges-le-Roi (91410)",
        "Antiquaire Les Molières (91470)",
        "Antiquaire Les Ulis (91940)",
        "Antiquaire Leudeville (91630)",
        "Antiquaire Leuville-sur-Orge (91310)",
        "Antiquaire Limours (91470)",
        "Antiquaire Linas (91310)",
        "Antiquaire Lisses (91090)",
        "Antiquaire Longjumeau (91160)",
        "Antiquaire Longpont-sur-Orge (91310)",

        "Antiquaire Maisse (91720)",
        "Antiquaire Marcoussis (91460)",
        "Antiquaire Marolles-en-Beauce (91150)",
        "Antiquaire Marolles-en-Hurepoix (91630)",
        "Antiquaire Massy (91300)",
        "Antiquaire Mauchamps (91730)",
        "Antiquaire Mennecy (91540)",
        "Antiquaire Mérobert (91780)",
        "Antiquaire Mespuits (91150)",
        "Antiquaire Milly-la-Forêt (91490)",
        "Antiquaire Moigny-sur-École (91490)",
        "Antiquaire Mondeville (91590)",
        "Antiquaire Monnerville (91930)",
        "Antiquaire Montgeron (91230)",
        "Antiquaire Montlhéry (91310)",
        "Antiquaire Morangis (91420)",
        "Antiquaire Morigny-Champigny (91150)",
        "Antiquaire Morsang-sur-Orge (91390)",
        "Antiquaire Morsang-sur-Seine (91250)",

        "Antiquaire Nainville-les-Roches (91750)",
        "Antiquaire Nozay (91620)",

        "Antiquaire Ollainville (91340)",
        "Antiquaire Oncy-sur-École (91490)",
        "Antiquaire Ormoy (91540)",
        "Antiquaire Ormoy-la-Rivière (91150)",
        "Antiquaire Orsay (91400)",
        "Antiquaire Orveau (91590)",

        "Antiquaire Palaiseau (91120)",
        "Antiquaire Paray-Vieille-Poste (91550)",
        "Antiquaire Pecqueuse (91470)",
        "Antiquaire Plessis-Saint-Benoist (91410)",
        "Antiquaire Prunay-sur-Essonne (91720)",
        "Antiquaire Puiselet-le-Marais (91150)",
        "Antiquaire Pussay (91740)",

        "Antiquaire Quincy-sous-Sénart (91480)",

        "Antiquaire Richarville (91410)",
        "Antiquaire Ris-Orangis (91130)",
        "Antiquaire Roinville (91410)",
        "Antiquaire Roinvilliers (91150)",

        "Antiquaire Saclas (91690)",
        "Antiquaire Saclay (91400)",
        "Antiquaire Saint-Aubin (91190)",
        "Antiquaire Saint-Chéron (91530)",
        "Antiquaire Saint-Cyr-la-Rivière (91690)",
        "Antiquaire Saint-Cyr-sous-Dourdan (91410)",
        "Antiquaire Saint-Escobille (91410)",
        "Antiquaire Saint-Germain-lès-Arpajon (91180)",
        "Antiquaire Saint-Germain-lès-Corbeil (91250)",
        "Antiquaire Saint-Hilaire (91780)",
        "Antiquaire Saint-Jean-de-Beauregard (91940)",
        "Antiquaire Saint-Maurice-Montcouronne (91530)",
        "Antiquaire Saint-Michel-sur-Orge (91240)",
        "Antiquaire Saint-Pierre-du-Perray (91280)",
        "Antiquaire Saint-Sulpice-de-Favières (91910)",
        "Antiquaire Saint-Vrain (91770)",
        "Antiquaire Saint-Yon (91650)",
        "Antiquaire Sainte-Geneviève-des-Bois (91700)",
        "Antiquaire Saintry-sur-Seine (91250)",
        "Antiquaire Saulx-les-Chartreux (91160)",
        "Antiquaire Savigny-sur-Orge (91600)",
        "Antiquaire Sermaise (91530)",
        "Antiquaire Soisy-sur-École (91840)",
        "Antiquaire Soisy-sur-Seine (91450)",
        "Antiquaire Souzy-la-Briche (91580)",

        "Antiquaire Tigery (91250)",
        "Antiquaire Torfou (91730)",

        "Antiquaire Valpuiseaux (91720)",
        "Antiquaire Varennes-Jarcy (91480)",
        "Antiquaire Vaugrigneuse (91640)",
        "Antiquaire Vauhallan (91430)",
        "Antiquaire Vayres-sur-Essonne (91820)",
        "Antiquaire Verrières-le-Buisson (91370)",
        "Antiquaire Vert-le-Grand (91810)",
        "Antiquaire Vert-le-Petit (91710)",
        "Antiquaire Videlles (91890)",
        "Antiquaire Vigneux-sur-Seine (91270)",
        "Antiquaire Villabé (91100)",
        "Antiquaire Villebon-sur-Yvette (91140)",
        "Antiquaire Villeconin (91580)",
        "Antiquaire Villejust (91140)",
        "Antiquaire Villemoisson-sur-Orge (91360)",
        "Antiquaire Villeneuve-sur-Auvers (91580)",
        "Antiquaire Villiers-le-Bâcle (91190)",
        "Antiquaire Villiers-sur-Orge (91700)",
        "Antiquaire Viry-Châtillon (91170)",

        "Antiquaire Wissous (91320)",

        "Antiquaire Yerres (91330)"
    ];
    return <ZoneIntervention departmentName="Essonne (91)" cities={cities} seoTitle={seo.title} seoDescription={seo.description} seoPath={seo.path} />;
}

export default Zone91;
